import * as types from './actionTypes';
import initialState from './initialState';

const dictionariesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.UPLOAD_CSV_REQUEST:
      return {
        ...state,
        upload: {
          ...state.upload,
          isLoading: true,
          error: [],
        },
      };
    case types.UPLOAD_CSV_SUCCESS:
      return {
        ...state,
        upload: {
          ...state.upload,
          isLoading: false,
        },
        show: {
          ...state.show,
          data: action.payload.csv,
        },
      };
    case types.UPLOAD_CSV_ERROR:
      return {
        ...state,
        upload: {
          ...state.upload,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.CANCEL_UPLOAD_CSV:
      return {
        ...state,
        upload: {
          ...state.upload,
          isLoading: false,
        },
      };
    case types.GET_CSV_REQUEST:
      return {
        ...state,
        show: {
          ...state.show,
          isLoading: true,
        },
      };
    case types.GET_CSV_SUCCESS:
      return {
        ...state,
        show: {
          ...state.show,
          isLoading: false,
        },
      };
    case types.GET_CSV_ERROR:
      return {
        ...state,
        show: {
          ...state.show,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.SAVE_CSV_REQUEST:
      return {
        ...state,
        save: {
          ...state.save,
          isLoading: true,
        },
      };
    case types.SAVE_CSV_SUCCESS:
      return {
        ...state,
        save: {
          ...state.save,
          isLoading: false,
        },
      };
    case types.SAVE_CSV_ERROR:
      return {
        ...state,
        save: {
          ...state.save,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.CANCEL_SAVE_CSV:
      return {
        ...state,
        save: {
          ...state.save,
          isLoading: false,
        },
      };
    case types.CLEAR_CSV:
      return {
        ...state,
        show: initialState.show,
        upload: initialState.upload,
      };
    default:
      return state;
  }
};

export default dictionariesReducer;
